<div fzOpenZenDesk [openZendeskAction]="modalError"></div>
<h2 mat-dialog-title class="header-text mat-headline-small no-margin">
  Preparing Game
</h2>

<mat-dialog-content class="match-making-dialog-content">
  <fz-alert severity="warning" [hideIcon]="true" class="mb--3">
    <fz-alert-message>
      Connectivity issues are your responsibility. If you experience issues or
      remain idle for over 2 minutes, we'll save your progress and score, and
      you'll stay active in the tournament.
    </fz-alert-message>
  </fz-alert>

  @if (agree && errorMessage !== 'The event code is not available') {
    <section class="game-options-list game-details-section bottom-spacer">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let key of objectKeys(steps)">
          <div class="list-texts">
            {{ steps[key].clientMessage }}
          </div>

          <div
            class="circle-loader"
            [ngClass]="{
              'load-complete':
                (steps[key].complete === true && steps[key].success === true) ||
                modalError === true,
              'load-error': steps[key].success !== true && modalError === true
            }"
          >
            <div
              *ngIf="
                (steps[key].complete === true && steps[key].success === true) ||
                (steps[key].success === true &&
                  steps[key].complete === undefined)
              "
              class="checkmark draw"
            ></div>
            <div
              [ngClass]="{
                show:
                  (steps[key].complete === true &&
                    steps[key].success !== true) ||
                  (steps[key].success !== true &&
                    steps[key].complete === undefined) ||
                  (steps[key].success === false && modalError === true)
              }"
              class="errormark draw"
            ></div>
          </div>
        </li>
      </ul>
      <div class="progress">
        <mat-progress-bar
          mode="determinate"
          color="#27ae60"
          [value]="processPercentComplete"
        ></mat-progress-bar>
      </div>
    </section>
  }
  @if (
    modalError === true &&
    errorMessage &&
    errorMessage !== 'Your wallet is frozen' &&
    errorMessage !== 'Insufficient Wallet Balance' &&
    (errorMessage === 'You must setup your FantaZ wallet' ||
      errorMessage.includes('duplicate'))
  ) {
    <section class="message-errors">
      <p class="text-danger mat-body-2">{{ errorMessage }}</p>
    </section>
  }
  @if (
    modalError === true &&
    (errorMessage === 'Your wallet is frozen' ||
      errorMessage === 'Insufficient Wallet Balance' ||
      errorMessage === 'You must setup your FantaZ wallet')
  ) {
    <section>
      <div
        class="buttons-ctn"
        *ngIf="modalError === true && errorMessage === 'Your wallet is frozen'"
      >
        <span
          >You are a high earner, great job! Please complete your
          <a (click)="redirect('/profile/tax-form')">Tax profile</a> before
          continue playing, it takes no time!
        </span>
      </div>
      <div
        class="buttons-ctn"
        *ngIf="
          modalError === true &&
          errorMessage === 'You must setup your FantaZ wallet'
        "
      >
        <span
          >You don't have a FantaZ wallet! Please
          <a (click)="redirect('user-game-profile')">
            complete your Player Profile</a
          >
          before continue playing, it takes no time!
        </span>
      </div>
      <div
        class="buttons-ctn"
        *ngIf="
          modalError === true && errorMessage === 'Insufficient Wallet Balance'
        "
      >
        <span>
          You don't have enough balance in your Z-Wallet. Please
          <a (click)="redirect('/wallet/deposit')"> add funds</a> to continue.
        </span>
      </div>
    </section>
  }
  @if (
    modalError === true && errorMessage === 'The event code is not available'
  ) {
    <section class="message-errors">
      <p>
        The event {{ eventCode }} is currently unavailable to join. Would you
        like to play in the next available event?
      </p>
      <mat-checkbox [checked]="userAutoPlay" (change)="handleAutoPlay($event)">
        <label>Don't ask me again.</label>
      </mat-checkbox>
    </section>
  }
  @if (
    modalError === true && errorMessage !== 'The event code is not available'
  ) {
    <section class="message-errors">
      <p class="mat-body-medium">
        Please visit our Support Center for troubleshooting tips and additional
        help.
      </p>
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions
  *ngIf="
    !(
      modalError === true &&
      (errorMessage === 'Your wallet is frozen' ||
        errorMessage === 'Insufficient Wallet Balance' ||
        errorMessage === 'You must setup your FantaZ wallet')
    )
  "
>
  <div class="dialog-action-container" *ngIf="agree === false">
    <button
      type="button"
      color="primary"
      mat-button
      mat-flat-button
      (click)="start()"
      data-ga-value="match-making-agree-button"
    >
      Agree
    </button>
    <button
      mat-button
      type="button"
      color="primary"
      mat-stroked-button
      (click)="close()"
      data-ga-value="match-making-decline-button"
    >
      Decline
    </button>
  </div>
  @if (
    modalError === true &&
    errorMessage !== 'Invalid Pass' &&
    errorMessage !== 'The event code is not available' &&
    errorMessage !== 'Inconsistent request, refresh the browser' &&
    errorMessage !== 'Your wallet is frozen' &&
    errorMessage !== 'You must setup your FantaZ wallet' &&
    errorMessage !== 'Insufficient Wallet Balance'
  ) {
    <div class="buttons-ctn">
      <button
        mat-stroked-button
        *ngIf="hideRetry === true"
        class="mat-flat-button"
        (click)="retry()"
        data-ga-value="match-making-retry-button"
      >
        Retry
      </button>
      <button
        mat-stroked-button
        class="mat-flat-button"
        (click)="close()"
        data-ga-value="match-making-close-button"
      >
        Close
      </button>
    </div>
  } @else if (
    modalError === true &&
    errorMessage === 'Inconsistent request, refresh the browser'
  ) {
    <div class="buttons-ctn">
      <button
        mat-flat-button
        color="primary"
        (click)="refreshPassInfo()"
        data-ga-value="match-making-refresh-button"
      >
        Refresh
      </button>
    </div>
  } @else if (modalError === true && errorMessage === 'Invalid Pass') {
    <div class="buttons-ctn">
      <button
        mat-flat-button
        color="primary"
        data-ga-value="match-making-play-button"
        (click)="continuePlayWithoutPass()"
      >
        <div>
          <span>
            Play -
            <fz-currency
              [value]="beginMatch?.scheduleSelected?.entryAmount"
            ></fz-currency
          ></span>
        </div>
      </button>
      <button
        mat-stroked-button
        class="mat-flat-button"
        (click)="redirectToRoom()"
        data-ga-value="match-making-buy-pass-button"
      >
        Buy Pass
      </button>
    </div>
  } @else if (
    modalError === true && errorMessage === 'The event code is not available'
  ) {
    <div class="buttons-ctn">
      <button
        mat-flat-button
        color="primary"
        data-ga-value="match-making-auto-play-button"
        (click)="continuePlayWithAutoPlay()"
      >
        Play
      </button>
      <button
        mat-stroked-button
        class="mat-flat-button"
        (click)="close()"
        data-ga-value="match-making-close-button"
      >
        Close
      </button>
    </div>
  }
</mat-dialog-actions>
